import { LitElement, html, Splide } from '@hh/global.js'

export class ProductFormVariantsSlideshow extends LitElement {
  static properties = {
    slider: { state: true },
  }

  connectedCallback() {
    super.connectedCallback()
    const slider = this.querySelector('[data-splide-slider]')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      arrows: true,
      pagination: false,
      autoplay: false,
      useScroll: true,
      fixedWidth: true,
      gap: 8,
      padding: 0,
      snap: true,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        980: {
          padding: 4,
          gap: 4,
        },
      },
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define(
  'product-form-variants-slideshow',
  ProductFormVariantsSlideshow
)
